<template>
  <div class="demo-emoji">
    <div class="demo-emoji-tabs">
      <div 
        :class="[
          'tab-item',
          { 
            active: currentTab === 'bear'
          }
        ]"
        v-on:click="$emit('selectTab', 'bear')"
      >
        <img :src="$getImgUrl(`assets/tabs/tab1.webp`)" />
      </div>
      <div 
        :class="[
          'tab-item',
          { 
            active: currentTab === 'bird'
          }
        ]"
        v-on:click="$emit('selectTab', 'bird')"
      >
        <img :src="$getImgUrl(`assets/tabs/tab2.webp`)" />
      </div>
    </div>

    <div class="demo-emoji-page">
      <div class="page">
        <div class="stickers-grid">
          <div 
            v-for="i in 15" 
            class="sticker-item" 
            :key="i"
            v-on:click="$emit('selectMessage', i)"
          >
            <img :src="$getImgUrl(`assets/stickers/${currentTab}/${i}.webp`)" />
          </div>
        </div>
      </div>
      <!-- <div class="page"></div> -->
    </div>

    <DemoHomeBar />
  </div>
</template>

<script>
import DemoHomeBar from './DemoHomeBar'

export default {
  props: {
    currentTab: {
      type: String,
      validator: v=> ['bear', 'bird'].includes(v)
    }
  },
  components: {
    DemoHomeBar
  }
}
</script>

<style lang="scss" scoped>

.demo-emoji {
  --demo-emoji-tab-width: 70px;
  --demo-emoji-tab-height: 54px;
  --demo-emoji-tab-gap: 25px;

  --demo-emoji-list-gutter: 14px 21px;

  --demo-emoji-width: 104px;
  --demo-emoji-height: 90px;
  --demo-emoji-gap: 10px 21px;
  background-color: #F9F9F9;

  @media screen and (max-width: 768px) {
    --demo-emoji-width: 80px;
    --demo-emoji-height: 70px;
    --demo-emoji-gap: 7px 13px;
    --demo-emoji-list-gutter: 11px;

    --demo-emoji-tab-width: 52px;
    --demo-emoji-tab-height: 45px;
  }
  @media screen and (max-width: 600px) {
    --demo-emoji-width: auto;
    --demo-emoji-height: auto;
  
  }
}

.demo-emoji-tabs {

  display: grid;
  grid-template-columns: repeat(2, var(--demo-emoji-tab-width));
  padding: 12px 20px;
  grid-gap: var(--demo-emoji-tab-gap);
  border-top: 1px solid #E5E5E5;
  border-bottom: 1px solid #E5E5E5;

}

.tab-item {
  width: var(--demo-emoji-tab-width);
  height: var(--demo-emoji-tab-height);

  img {
    width: 100%;
    height: auto;
    filter: grayscale(1);
  }
  &.active img {
    filter: none;
  }
}

.page {
  padding: var(--demo-emoji-list-gutter);
  background-color: #F9F9F9;
}

.stickers-grid {
  display: grid;
  grid-template-columns: repeat(5, var(--demo-emoji-width));
  grid-gap: var(--demo-emoji-gap);
  
}

.sticker-item {
  width: 100%;
  height: var(--demo-emoji-height);
  img {
    display: block;
    width: 100%;
    height: auto;
  }
}

</style>